import {
	BoxSeriesType,
	BoxType,
	ChartletType,
	DialogAssignPage,
	OnoffType,
} from '@/api/enum/common.enum';

export const PUBLISHED_LISTA = [
	{
		id: OnoffType.off,
		name: '待上架',
	},
	{
		id: OnoffType.on,
		name: '已上架',
	},
];

export const PUBLISHED_LISTB = [
	{
		id: OnoffType.tobeOn,
		name: '待上架',
	},
	{
		id: OnoffType.on,
		name: '已上架',
	},
	{
		id: OnoffType.off,
		name: '已下架',
	},
];

export const PUBLISHED_LIST_ = [
	{
		id: OnoffType.on,
		name: '上架',
	},
	{
		id: OnoffType.off,
		name: '下架',
	},
];

export const BOXTYPE = [
	{
		id: BoxType.SeriesBox,
		name: '系列盲盒',
	},
	{
		id: BoxType.MixtureBox,
		name: '混合盲盒',
	},
];

export const BOX_SERIES_TYPE = [
	{
		id: BoxSeriesType.Gallery,
		name: '色彩畫廊',
	},
	{
		id: BoxSeriesType.Puzzle,
		name: '神秘拼圖',
	},
	{
		id: BoxSeriesType.Email,
		name: '集郵之旅',
	},
	{
		id: BoxSeriesType.Card,
		name: '靜心語錄',
	},
	{
		id: BoxSeriesType.Chartlet,
		name: '聊天貼圖',
	},
];

export const CHARTLET_TYPE = [
	{
		id: ChartletType.Dynamic,
		name: '動態貼圖',
	},
	{
		id: ChartletType.Static,
		name: '靜態貼圖',
	},
];

export const DIALOG_LIST_PAGE = [
	{ id: DialogAssignPage.Index, name: '主頁' },
	{ id: DialogAssignPage.NowNeed, name: '此刻所需列表' },
	{ id: DialogAssignPage.Exercise, name: '練習庫' },
	{ id: DialogAssignPage.Search, name: '搜尋頁' },
	{ id: DialogAssignPage.Day21, name: '21天練習系列列表' },
	{ id: DialogAssignPage.MyData, name: '個人資料' },
	{ id: DialogAssignPage.Setting, name: '設定' },
	{ id: DialogAssignPage.Task, name: '任務中心' },
	{ id: DialogAssignPage.Achievement, name: '成就寶庫' },
	{ id: DialogAssignPage.Exchange, name: '兌換中心' },
	{ id: DialogAssignPage.Collect, name: '我的收藏' },
	{ id: DialogAssignPage.Record330, name: '我的330紀錄' },
	{ id: DialogAssignPage.AboutUs, name: '關於我們' },
	{ id: DialogAssignPage.MoreEmo, name: '更多情緒支援' },
	{ id: DialogAssignPage.QA, name: '常見問題' },
	{ id: DialogAssignPage.Information330, name: '更多解說' },
	{ id: DialogAssignPage.Health, name: '330健康指數' },
	{ id: DialogAssignPage.Body, name: '心靈樽頁面' },
	{ id: DialogAssignPage.Major, name: '進階課程頁面' },
	{ id: DialogAssignPage.Clock, name: '練習時計頁面' },
];

export const TASK_LIST_PAGE = [
	{ id: DialogAssignPage.Index, name: '主頁' },
	{ id: DialogAssignPage.NowNeed, name: '此刻所需列表' },
	{ id: DialogAssignPage.Exercise, name: '練習庫' },
	{ id: DialogAssignPage.Search, name: '搜尋頁' },
	{ id: DialogAssignPage.Day21, name: '21天練習系列列表' },
	{ id: DialogAssignPage.MyData, name: '個人資料' },
	{ id: DialogAssignPage.Setting, name: '設定' },
	{ id: DialogAssignPage.Achievement, name: '成就寶庫' },
	{ id: DialogAssignPage.Exchange, name: '兌換中心' },
	{ id: DialogAssignPage.Collect, name: '我的收藏' },
	{ id: DialogAssignPage.Record330, name: '我的330紀錄' },
	{ id: DialogAssignPage.AboutUs, name: '關於我們' },
	{ id: DialogAssignPage.MoreEmo, name: '更多情緒支援' },
	{ id: DialogAssignPage.QA, name: '常見問題' },
	{ id: DialogAssignPage.Information330, name: '更多解說' },
	{ id: DialogAssignPage.Health, name: '330健康指數' },
	{ id: DialogAssignPage.Body, name: '心靈樽頁面' },
	{ id: DialogAssignPage.Major, name: '進階課程頁面' },
	{ id: DialogAssignPage.Clock, name: '練習時計頁面' },
];
